export default __webpack_public_path__ + "static/media/Custom-HUD-Header (3 Layers).24e60480.jpg";